import styled from "styled-components";

export const Header = styled.div`
display: flex;
flex-flow: row nowrap;
width: 100%;
position: absolute;
z-index: 10;
background: inherit;
`
export const HeaderContainer = styled.div`
margin-left: auto;
margin-right: auto;
width: 100%;
padding-right: 15px;
padding-left: 15px;
`

export const StyledNav = styled.nav`
display: flex;
flex-flow: row wrap;
padding: 20px 10px 20px 10px;
justify-content: space-between;
`
export const NavButton = styled.button`
background: #1E40C8 0% 0% no-repeat padding-box;
border-radius: 24px;
padding: 8px 10px 8px 10px;
border: none;
text-align: left;
letter-spacing: -0.2px;
color: #FFFFFF;
font-size: 16px;
cursor: pointer;
margin-right: 5px;
margin-left: 5px;
`
export const NavBar = styled.div`
display: flex;
flex-flow: row wrap;
justify-content: end;
`